import { PureComponent } from 'react';

class CoreProduct extends PureComponent {

  constructor(props) {
    super(props);

    this.unique = 'isDef';
  }


  render() {
    console.log('basic');
    return 'true';
  }


}

export default CoreProduct;



/** WEBPACK FOOTER **
 ** ./core_modules/Product/CoreProduct.js
 **/